import assign from '@ali/xutil/assign';
import gatewaySettings from '../common/qianniu-gateway-settings';
import gatewayByNative from './qianniu-pc-gateway-by-native';
import gatewayByAjax from './qianniu-gateway-by-ajax';

export default (X) => {

  let _gatewayByNative = gatewayByNative(X);
  let _gatewayByAjax = gatewayByAjax(X);

  let gateway = {

    setup: gatewaySettings.setup,

    invoke(options) {
      // To support api alias, we need to get api info from api map.
      let settings = assign.deep({}, gatewaySettings.get(), options.settings || {});
      let gateway = settings.useAjax ? _gatewayByAjax : _gatewayByNative;

      return gateway.invoke(options);
    }
  };

  return gateway;
}



// WEBPACK FOOTER //
// ./src/plugins/qianniu-pc-gateway.js